import api from "../../../services/api";

// Cada card de KPI da Central de Alertas tem sua própria rota no backend
// (ver PLANO_CENTRAL_ALERTAS.md em link-sale-backend) — todas recebem o
// mesmo body e devolvem { atual, anterior } de UM campo só. O backend já
// calcula o período anterior a partir de initial_date/final_date (mesma
// duração, imediatamente antes), então cada rota é chamada uma única vez.
//
// `campo` é o nome usado dentro de kpis.atual/kpis.anterior — mesmo shape
// que o motor de correlação local (utils/centralDeAlertas/correlacao.js)
// produzia, para o KpiCards não precisar saber se o dado é real ou mockado.
const ENDPOINTS_KPI = [
	{ campo: "totalAlertas", rota: "/find/centralAlertas/totalAlertas" },
	{ campo: "alertasCriticos", rota: "/find/centralAlertas/alertasCriticos" },
	{ campo: "pctSemAtendimento", rota: "/find/centralAlertas/semAtendimento" },
	{
		campo: "pctAtendimentosSemOs",
		rota: "/find/centralAlertas/atendimentosSemOs",
	},
	{ campo: "mttaMedio", rota: "/find/centralAlertas/mttaMedio" },
	{ campo: "mttrMedio", rota: "/find/centralAlertas/mttrMedio" },
	{ campo: "pctSlaCumprido", rota: "/find/centralAlertas/slaCumprido" },
	{
		campo: "incidentesAbertos",
		rota: "/find/centralAlertas/incidentesAbertos",
	},
];

// Busca os 8 KPIs em paralelo (Promise.allSettled: uma rota falhando não
// derruba as outras 7 — o backend também dedupla/cacheia essas 8 chamadas
// simultâneas internamente, então isso não custa 8x lá).
//
// filterClientes/filterEquipamentos JÁ são enviados: os dropdowns usam ids
// reais (Clientes.id / hostId Zabbix) vindos de /find/centralAlertas/filtros
// (ver apiFiltros.js), que o backend honra em todas as rotas do dashboard.
export async function buscarKpis({
	inicio,
	fim,
	filterClientes,
	filterEquipamentos,
	filterSeveridades,
	erpId,
	signal,
}) {
	const body = {
		initial_date: inicio.toISOString(),
		final_date: fim.toISOString(),
		// ERP escolhido no painel (sem ERP cadastrado: a variável ERP).
		erpId: erpId || undefined,
		...(filterClientes?.length ? { filterClientes } : {}),
		...(filterEquipamentos?.length ? { filterEquipamentos } : {}),
		...(filterSeveridades?.length ? { filterSeveridades } : {}),
	};

	const resultados = await Promise.allSettled(
		ENDPOINTS_KPI.map(({ rota }) => api.post(rota, body, { signal })),
	);

	const atual = {};
	const anterior = {};
	resultados.forEach((resultado, indice) => {
		const { campo } = ENDPOINTS_KPI[indice];
		if (resultado.status === "fulfilled") {
			atual[campo] = resultado.value?.data?.atual ?? null;
			anterior[campo] = resultado.value?.data?.anterior ?? null;
		} else {
			console.error(
				`Erro ao buscar "${campo}" da Central de Alertas:`,
				resultado.reason,
			);
			atual[campo] = null;
			anterior[campo] = null;
		}
	});

	return { atual, anterior };
}
